import React from 'react';
import comedora from '../assets/comedora-menu-logo-transparent.png';
import granada from '../img/granada.png';
import guasasapo from '../assets/trincheta-sello-nuevo-transparent.png';
import guasasapotv from '../img/gtv.png';
import trincheta from '../img/trincheta.png';
import trinchetaMenuLogo from '../assets/trincheta-menu-logo-transparent.png';
import guasasapoFondoCasa from '../assets/guasasapo-fondo-casa-enhanced-v2.jpg';

const navItems = ['INFO', 'FUNCIONAMIENTO', 'CRONOLOGIA', 'HAZTE PARTE', 'CONTACTO'];

const brandMarks = [
  { src: comedora, alt: 'Comedora', href: '/comedora', className: 'guasasapoLanding__navBrandMark--comedora' },
  { src: trincheta, alt: 'Trincheta', href: '/trincheta' },
  { src: granada, alt: 'Granada', href: '/granada' },
  { src: guasasapotv, alt: 'Guasasapo TV', href: '/guasasapotv' },
];

const Guasasapo = () => {
  return (
    <div
      className="guasasapoLanding"
      style={{
        backgroundImage: `linear-gradient(rgba(18, 28, 44, 0.42), rgba(18, 28, 44, 0.42)), linear-gradient(rgba(88, 102, 118, 0.12), rgba(88, 102, 118, 0.12)), url(${guasasapoFondoCasa})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <nav className="guasasapoLanding__nav">
        <div className="guasasapoLanding__navBrandCluster">
          <a href="/guasasapo" className="guasasapoLanding__navLogo">
            <img src={guasasapo} alt="Guasasapo" />
          </a>

          <div className="guasasapoLanding__navBrandMenu">
            {brandMarks.map((mark) => (
              <a key={mark.href} href={mark.href} className={`guasasapoLanding__navBrandMark ${mark.className || ''}`}>
                <img src={mark.src} alt={mark.alt} />
              </a>
            ))}
          </div>
        </div>

        <div className="guasasapoLanding__navRight">
          <ul className="guasasapoLanding__navList">
            {navItems.map((item) => (
              <li key={item}>
                <a href={item === 'CRONOLOGIA' ? '/cronologia' : `#${item.toLowerCase().replace(/\s+/g, '-')}`} className="guasasapoLanding__navLink">
                  {item}
                </a>
              </li>
            ))}
          </ul>

          <img src={trinchetaMenuLogo} alt="Guasasapo Arte y Producción Cooperativa Abierta" className="guasasapoLanding__navSupportLogo" />
        </div>
      </nav>

      <main className="guasasapoLanding__main">
        <div className="guasasapoLanding__hero">
          <div className="guasasapoLanding__heroLogo" aria-label="Guasasapo">
            <img src={guasasapo} alt="Guasasapo" className="guasasapoLanding__heroLogoMain" />
          </div>
          <div className="guasasapoLanding__heroDivider" />
          <p className="guasasapoLanding__tagline">Cooperativa abierta de arte y producción</p>
          <p className="guasasapoLanding__subtitle">ANTIESPECISTA · ANTIPATRIARCAL · ANTICAPITALISTA · ARTE Y AUTOEDUCACIÓN ÁCRATA</p>
        </div>
      </main>

      <footer className="guasasapoLanding__footer">
        <span className="guasasapoLanding__footerText">GUASASAPO</span>
        <span className="guasasapoLanding__footerDot">&middot;</span>
        <span className="guasasapoLanding__footerText">COOPERATIVA ABIERTA</span>
      </footer>
    </div>
  );
};

export default Guasasapo;
